"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rgbToStr;
// prettier-ignore
function rgbToStr([r, g, b]) {
  return "rgb(" + r + ", " + g + ", " + b + ")";
}